"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emoji_service_1 = require("./src/emoji.service");
exports.EmojiService = emoji_service_1.EmojiService;
var emoji_input_component_1 = require("./src/emoji-input/emoji-input.component");
exports.EmojiInputComponent = emoji_input_component_1.EmojiInputComponent;
var emoji_picker_module_1 = require("./emoji-picker.module");
exports.EmojiPickerModule = emoji_picker_module_1.EmojiPickerModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/ng-emoji-picker/index.js
// module id = ../../../../ng-emoji-picker/index.js
// module chunks = dashboard.module